export const ReservationTypesConstant = {
    General: 1,
    Birthday: 2,
    SchoolTrip: 4
}